import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-general-2v2',
  templateUrl: './2v2.component.html',
})
export class CuiGeneral2v2Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
